<template>
  <div style="padding-top: 60px">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$router.back()" class="header-back"></a>
      </div>
      <div class="header-center">
        <a @click="$parent.goNav('/')" class="header-logo"> <img :src="$store.state.appInfo.site_logo || '/static/image/d11_logo_h5.png'" onerror="this.src = '/static/image/d11_logo_h5.png'" width="100%" /> </a>
        <h4 class="header-title hide"></h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
      </div>
    </div>
    <div class="layout mt12">
      <ul class="mod-f-l mt15">
        <li class="no-next">
          <a href="javascript:void(0)"
            ><span class="fr f14px c6">{{ $store.state.userInfo.username }}</span
            ><span class="tit"><i class="usr-name"></i>用户名称</span></a
          >
        </li>

        <li class="no-next">
          <a id="goeditrName_btn"
            ><span class="fr f14px c6">{{ $store.state.userInfo.realname }}</span
            ><span class="tit"><i class="real-name"></i>真实姓名</span></a
          >
        </li>

        <li class="no-next" @click="changShow">
          <a id="goinsertDOB_btn"
            ><span class="fr f14px c6">{{ birthday }}</span
            ><span class="tit"><i class="birth-icon"></i>出生日期</span></a
          >
        </li>
        <van-datetime-picker type="date" v-if="showPicker" :min-date="minDate" @confirm="onConfirm" @cancel="changShow" />
      </ul>

      <ul class="mod-f-l mt15">
        <li class="no-next">
          <a id="goinsertEmail_btn"
            ><span class="fr f14px c6" style="max-width: 60%; word-break: break-all"> <input type="text" v-model="email" placeholder="请输入邮箱" style="border: none; text-align: right" /> </span><span class="tit"><i class="email-icon"></i>邮箱地址</span></a
          >
        </li>

        <li class="no-next">
          <a id="phoneNum_btn"
            ><span class="fr f14px c6"> <input type="text" v-model="mobile" placeholder="请输入手机号" style="border: none; text-align: right" /></span>

            <span class="tit"><i class="cell-icon"></i>手机号码 </span></a
          >
        </li>
      </ul>

      <div class="p15 mtb15">
        <a class="confirm-sub" @click="isOk" id="logout_btn">保存</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'userInfo',
  data() {
    return {
      mobile: null,
      email: null,
      birthday: null,
      showPicker: false,
      minDate: new Date(1980, 0, 1),
    };
  },
  created() {
    let that = this;
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    that.mobile = userInfo.mobile;
    that.email = userInfo.email;
    that.birthday = userInfo.birthday;
  },
  methods: {
    timeFormat(time) {
      var time = new Date(time.getTime() + 8 * 60 * 60 * 1000);
      var myDate = time.toJSON().split('T').join(' ').substr(0, 10);
      return myDate;
    },
    changShow() {
      this.showPicker = !this.showPicker;
    },
    onConfirm(time) {
      let that = this;
      this.birthday = that.timeFormat(time);
      this.showPicker = false;
    },
    isOk() {
      let that = this;
      let info = { email: that.email, mobile: that.mobile, birthday: that.birthday };
      console.log(that.birthday);
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      let regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      let dateFormat = /^(\d{4})-(\d{2})-(\d{2})$/;
      if (!regExp.test(that.mobile)) {
        that.$parent.showTost(0, '请输入正确手机号');
        return;
      }
      if (!regEmail.test(that.email)) {
        that.$parent.showTost(0, '请输入正确邮箱号');
        return;
      }
      if (!dateFormat.test(that.birthday)) {
        that.$parent.showTost(0, '请输入正确的日期格式：YYYY-MM-DD');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun
        .post('/api/updateuserinfo', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.mobile = info.mobile;
            userInfo.email = info.email;
            userInfo.birthday = info.birthday;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$parent.getUserInfo();
            that.$parent.showTost(1, '操作成功');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    onchangemd(e) {
      let that = this;

      console.log(e.target.files); //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        console.log(item);
        formdata.append('file', item); //将每一个文件图片都加进formdata
      });
      //  axios.post("接口地址", formdata).then(res => { console.log(res) })
      that.$parent.showLoading();
      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.getUserInfoShowLoding();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.mod-f-l li.no-next,
.mod-f-l li a {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/userInfo.vue